/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type RoamingInfoRoamingStatus =
  (typeof RoamingInfoRoamingStatus)[keyof typeof RoamingInfoRoamingStatus];

export const RoamingInfoRoamingStatus = {
  active: "active",
  ready: "ready",
  ordered: "ordered",
  na: "na",
} as const;
